import { useQuery } from "@tanstack/react-query";
import { fetchWalletStatus } from "@/api/billing";
import { queryKeys } from "@/lib/query-keys";

/**
 * Loads wallet resume state only after an organization is available. Errors are
 * exposed without automatic retries so the NUX container can choose recovery.
 */
export const useWalletStatus = (organizationId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.billing.wallet(organizationId ?? "none"),
    queryFn: () => fetchWalletStatus(organizationId as string),
    enabled: !!organizationId,
    retry: false,
  });
};
